import { defineStore } from 'pinia'

function todayIso() {
  const now = new Date()
  const yyyy = now.getFullYear()
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  const dd = String(now.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

function defaultRange() {
  const today = todayIso()
  const yearStart = `${today.slice(0, 4)}-01-01`
  return { from: yearStart, to: today }
}

export const useDateRangeStore = defineStore('dateRange', {
  state: () => ({
    ranges: {
      business: defaultRange(),
      operations: defaultRange()
    }
  }),
  actions: {
    getRange(page) {
      return this.ranges[page]
    },
    setRange(page, range){
        this.ranges[page] = range
    }
  }
})